// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;I say to God my rock,<br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#145;Why have you forgotten me,&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;and why go I so heavily, while the enemy oppresses me?&#146;<br> </p> </div></div>";
// Exports
module.exports = code;